import api from '@/services/api'

const getCategoryCount = async (userId, filters, role) => {
    try {
        const resp = await api.post(
            `/feedbacks/list/${userId}/dashboard/category`,
            {
                type: 'sent',
                ...filters,
                scope: role,
            }
        )

        return resp.data.data
    } catch (e) {
        console.error(e)
        throw e
    }
}

export { getCategoryCount }
